/* Omaggio per clienti selezionati — logica carrello (vedi snippets/omaggio.liquid) */
(function () {
  if (customElements.get('omaggio-box')) return;

  var STILE = [
    '.omaggio-box{display:block;margin:0 0 16px;padding:14px 16px;border:1px solid rgba(0,0,0,.12);border-radius:8px;font-size:14px;line-height:1.45}',
    '.omaggio-box--vuoto{display:none}',
    '.omaggio-box__testo{margin:0}',
    '.omaggio-box__titolo{display:block;font-weight:600;margin-bottom:2px}',
    '.omaggio-box__attesa{opacity:.6}',
    '.omaggio-box__riga{display:flex;gap:8px;margin-top:10px}',
    '.omaggio-box__input{flex:1 1 auto;min-width:0;height:42px;padding:0 12px;border:1px solid rgba(0,0,0,.25);border-radius:6px;font-size:16px;background:#fff;color:inherit}',
    '.omaggio-box__bottone{flex:0 0 auto;height:42px;padding:0 16px;border:1px solid currentColor;border-radius:6px;background:transparent;color:inherit;font-size:13px;font-weight:600;letter-spacing:.04em;text-transform:uppercase;cursor:pointer}',
    '.omaggio-box__bottone[disabled]{opacity:.5;cursor:default}',
    '.omaggio-box__esito{margin:8px 0 0;font-size:13px}',
    '.omaggio-box__esito--errore{color:#b3261e}'
  ].join('');
  var s = document.createElement('style');
  s.textContent = STILE;
  document.head.appendChild(s);

  function json(url, opts) {
    return fetch(url, Object.assign({ credentials: 'same-origin' }, opts || {})).then(function (r) {
      return r.text().then(function (t) {
        var d = null;
        try { d = JSON.parse(t); } catch (e) { d = null; }
        if (!r.ok) { var err = new Error((d && (d.description || d.message)) || ('HTTP ' + r.status)); err.dati = d; throw err; }
        return d;
      });
    });
  }
  function post(url, body) {
    return json(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
  }


  function emailRicordata() { try { return localStorage.getItem('omaggio_email') || ''; } catch (e) { return ''; } }
  function ricordaEmail(e) { try { localStorage.setItem('omaggio_email', e); } catch (x) {} }

  // Scrive l'email negli attributi del carrello e ricontrolla: altre app toccano il carrello al
  // caricamento (es. igId) e possono scavalcare una scrittura fatta troppo presto.
  function assicuraAttributo(email, root) {
    var tentativi = 0;
    function giro() {
      tentativi++;
      return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
        if (c && c.attributes && c.attributes.omaggio_email === email) return true;
        return post(root + 'cart/update.js', { attributes: { omaggio_email: email } }).then(function () { return false; });
      }).catch(function () { return false; });
    }
    return giro().then(function (ok) {
      if (ok || tentativi >= 3) return;
      return new Promise(function (res) { setTimeout(res, 3500); }).then(giro).then(function (ok2) {
        if (ok2) return;
        return new Promise(function (res) { setTimeout(res, 5000); }).then(giro);
      });
    });
  }

  // Link personalizzato dalle email (es. Klaviyo): https://negozio/?omaggio={{ email }}
  // L'email viene ricordata nel browser e scritta negli attributi del carrello: da lì in poi il
  // regalo entra da solo al raggiungimento della soglia. L'idoneità resta verificata dal server.
  (function () {
    try {
      var p = new URLSearchParams(location.search).get('omaggio');
      if (!p) return;
      var email = String(p).trim().toLowerCase();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return;
      ricordaEmail(email);
      var u = new URL(location.href); u.searchParams.delete('omaggio'); history.replaceState(null, '', u.toString());
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      assicuraAttributo(email, root);
    } catch (e) {}
  })();

  var MEM = 'omaggio_tentativi';
  function tentativi(chiave, incrementa) {
    try {
      var m = JSON.parse(sessionStorage.getItem(MEM) || '{}');
      if (incrementa) { m[chiave] = (m[chiave] || 0) + 1; sessionStorage.setItem(MEM, JSON.stringify(m)); }
      return m[chiave] || 0;
    } catch (e) { return 0; }
  }

  class OmaggioBox extends HTMLElement {
    connectedCallback() {
      var root = this.dataset.root || '/';
      this.urlAdd = root + 'cart/add.js';
      this.urlChange = root + 'cart/change.js';
      this.urlUpdate = root + 'cart/update.js';
      var form = this.querySelector('.omaggio-box__form');
      if (form) {
        var self = this;
        form.querySelector('button').addEventListener('click', function (e) { e.preventDefault(); self.verificaEmail(form); });
        form.querySelector('input').addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); self.verificaEmail(form); } });
        var attr = this.dataset.email;
        if (attr) form.querySelector('input').value = attr;
      }
      var azione = this.dataset.azione;
      if (this.dataset.key && this.dataset.email) this.applicaCodice();
      if (form && !this.dataset.email && emailRicordata()) {
        var ric = emailRicordata();
        form.querySelector('input').value = ric;
        this.dataset.silenzioso = '1';
        this.verificaEmail(form, ric);
        return;
      }
      if (azione === 'nessuna') return;
      // Un'azione automatica per riga: al massimo 3 tentativi per sessione, poi ci si ferma.
      var chiave = azione + ':' + (this.dataset.key || this.dataset.variante);
      if (tentativi(chiave, false) >= 3) return;
      tentativi(chiave, true);
      if (azione === 'aggiungi') this.aggiungi();
      else if (azione === 'rimuovi') this.cambia(this.dataset.key, 0);
      else if (azione === 'quantita') this.cambia(this.dataset.key, 1);
      else if (azione === 'verifica') this.verificaEmail(null, this.dataset.email);
    }

    verificaEmail(form, emailDiretta) {
      var self = this;
      var input = form ? form.querySelector('input') : null;
      var bottone = form ? form.querySelector('button') : null;
      var esito = form ? form.querySelector('.omaggio-box__esito') : null;
      var silenzioso = this.dataset.silenzioso === '1';
      var email = String(emailDiretta || (input && input.value) || '').trim().toLowerCase();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { self.mostra(esito, 'Inserisci un indirizzo email valido.', true); return; }
      if (bottone) bottone.disabled = true;
      self.mostra(esito, 'Verifichiamo…', false);
      json(this.dataset.verificaUrl + '?email=' + encodeURIComponent(email), { headers: { Accept: 'application/json' } })
        .then(function (d) {
          if (!d || d.ok !== true) {
            if (silenzioso) { self.nascondi(); return; }
            self.mostra(esito, d && d.motivo === 'non_cliente' ? 'Non troviamo un account cliente con questa email.' : 'Questa email non ha un omaggio riservato.', true);
            if (bottone) bottone.disabled = false;
            return;
          }
          ricordaEmail(email);
          return post(self.urlUpdate, { attributes: { omaggio_email: email } })
            .then(function () { return self.applicaCodice(); })
            .then(function () { return self.aggiungi(); });
        })
        .catch(function (e) {
          if (silenzioso) { self.nascondi(); return; }
          self.mostra(esito, 'Non riusciamo a verificare adesso. Riprova tra poco.', true);
          if (bottone) bottone.disabled = false;
          console.warn('omaggio: verifica fallita', e);
        });
    }

    nascondi() { this.classList.add('omaggio-box--vuoto'); }

    // Aggancia il codice sconto riservato alla sessione: Shopify lo porta al checkout da solo.
    applicaCodice() {
      var codice = this.dataset.codice;
      if (!codice) return Promise.resolve();
      var root = this.dataset.root || '/';
      return fetch(root + 'discount/' + encodeURIComponent(codice) + '?redirect=' + encodeURIComponent(root + 'cart'), { credentials: 'same-origin' })
        .catch(function (e) { console.warn('omaggio: codice non agganciato', e); });
    }

    aggiungi() {
      var self = this;
      var id = parseInt(this.dataset.variante, 10);
      if (!id) return Promise.resolve();
      return post(this.urlAdd, { items: [{ id: id, quantity: 1, properties: { _omaggio: '1' } }] })
        .then(function () { self.aggiorna(); })
        .catch(function (e) {
          console.warn('omaggio: aggiunta fallita', e);
          var p = self.querySelector('.omaggio-box__attesa');
          if (p) p.textContent = 'L\'omaggio non è disponibile al momento.';
        });
    }

    cambia(key, quantita) {
      var self = this;
      if (!key) return;
      post(this.urlChange, { id: key, quantity: quantita })
        .then(function () { self.aggiorna(); })
        .catch(function (e) { console.warn('omaggio: modifica fallita', e); });
    }

    mostra(el, testo, errore) {
      if (!el) return;
      el.hidden = false;
      el.textContent = testo;
      el.classList.toggle('omaggio-box__esito--errore', !!errore);
    }

    // Dopo una modifica al carrello: nel mini-cart si ricarica la sezione come fa il tema,
    // nella pagina carrello si ricarica la pagina.
    aggiorna() {
      var dentroMini = this.closest('#form-mini-cart');
      var root = this.dataset.root || '/';
      if (!dentroMini) { window.location.reload(); return; }
      fetch(root + '?sections=form-mini-cart', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (sezioni) {
          var html = new DOMParser().parseFromString(sezioni['form-mini-cart'] || '', 'text/html');
          var nuovo = html.querySelector('#form-mini-cart');
          var attuale = document.getElementById('form-mini-cart');
          if (nuovo && attuale) attuale.innerHTML = nuovo.innerHTML;
          return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          if (!cart) return;
          document.querySelectorAll('.cart-count').forEach(function (el) {
            el.innerHTML = el.classList.contains('cart-count-drawer') ? '(' + cart.item_count + ')' : cart.item_count;
          });
          var htp = document.querySelector('header-total-price');
          if (htp && typeof htp.updateTotal === 'function') htp.updateTotal(cart);
        })
        .catch(function () { window.location.reload(); });
    }
  }
  customElements.define('omaggio-box', OmaggioBox);
})();
